import { useState, useEffect } from 'react';
import axios from 'axios';

export default function useFindUser() {
	const [user, setUser] = useState(null);
	const [isLoading, setLoading] = useState(true);

	useEffect(() => {
		function findUser() {
			const user = localStorage.getItem('@App:user');
			const token = localStorage.getItem('@App:token');

			if (user && token) {
				setUser(JSON.parse(user));
				axios.defaults.headers.Authorization = `Bearer ${token}`;
			}

			setLoading(false);
		}
		findUser();
	}, []);

	return {
		user,
		setUser,
		isLoading,
	};
}
